// https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
const reflow = ($el) => $el.width();

const hide = ($collapse) => {
  if ($collapse.hasClass('collapsing-horizontal')) {
    return;
  }

  if (!$collapse.hasClass('show')) {
    return;
  }

  const width = $collapse.width();

  if (width === 0) {
    // Element isn't visible so no need to animate
    $collapse.removeClass('show');

    return;
  }

  // Sets initial width
  $collapse.width(width);

  // Force element layout
  reflow($collapse);

  // Listen for CSS transition to complete
  $collapse.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
    $collapse.removeClass('show collapsing-horizontal').addClass('collapse-horizontal');
  });

  // Transition to zero width
  $collapse.removeClass('collapse-horizontal').addClass('collapsing-horizontal').width('');
};

const show = ($collapse) => {
  if ($collapse.hasClass('collapsing-horizontal')) {
    return;
  }

  // Hide current collapse
  const $parent = jQuery($collapse.data('bs-parent') || $collapse.data('parent'));
  if ($parent.length) {
    const $active = $parent.data('active-collapse');
    if ($active === $collapse[0]) {
      return;
    }

    if ($active) {
      hide(jQuery($active));
    }
    $parent.data('active-collapse', $collapse[0]);
  }

  if ($collapse.hasClass('show')) {
    return;
  }

  const width = $collapse.width();

  if (width === 0) {
    // Element isn't visible so no need to animate
    $collapse.addClass('show');

    return;
  }

  // Sets zero width
  $collapse.removeClass('collapse-horizontal').addClass('collapsing-horizontal');

  // Listen for CSS transition to complete
  $collapse.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
    $collapse.removeClass('collapsing-horizontal').addClass('show collapse-horizontal').width('');
  });

  // Transition to desired width
  $collapse.width(width);
};

jQuery.fn.extend({
  horizontalCollapse(opts) {
    this.each(function () {
      const $collapse = jQuery(this);

      if (opts === 'show') {
        show($collapse);
      } else if (opts === 'hide') {
        hide($collapse);
      }
    });
  },
});

jQuery(function ($) {
  $('.collapse-horizontal.show').horizontalCollapse('show');
});
